<template>
  <div class="col-24" style="background-color:#fefefe;margin-top:7px;padding-top:7px;min-height:69px;border-bottom: 1px solid #ccc;margin-bottom:15px;height: 100%;">
     <div>
        <div class="product-thumbx" style="float:left;width:15%;">
           <img :src="getPicture" alt="" style="max-height:65px;border-radius:10px">
        </div>
        <div  style="float:left;width:60%;word-wrap: break-word;font-weight:600;margin-left:5px">
          {{product.Title}}<br><span style="font-weight:400">{{getDuration ()}} {{getProdPrice ()}}</span>
          <template v-if="this.hasPackageData"><br><span style="font-size:10px">{{getPackageData ()}}</span></template>
          <span v-if="product.Detail.length > 3"><br><span v-html="product.Detail" style="font-weight:100;font-size:smaller;"></span></span>
        </div>
        <div  style="float:right;width:15%">
          <product-button :product="product" style="float:right;background-color:#fff"></product-button>
        </div>
     </div>
  </div>
</template>

<script>
  import ProductButton from './ProductButton.vue'
  import Vue from 'vue';

  export default {
    name: 'product-item',
    props: ['product'],
    components: {
      'product-button': ProductButton
    },
     data () {
      return {
        urlPicCat : '',
        isHideTime : false,
        isHidePrice : false
      }
    },
    mounted () {
       this.urlPicCat = '';
       this.urlPicCat = Vue.$currCatPicUrl;

       if (Vue.$storeSettings != undefined)
       {
          this.isHideTime = Vue.$storeSettings.IsHideTime;
          this.isHidePrice =  Vue.$storeSettings.IsHidePrice;
       }
       
      // console.log ("loading pic 1:" + Vue.$currCatPicUrl)
    },
    activated () {
      //console.log ("loading pic :" + Vue.$currCatPicUrl)
      this.urlPicCat = Vue.$currCatPicUrl;
    },
    methods: {
       getDuration () {
          if (this.isHideTime) return " "
          if (this.product.IntDuration <= 0) return "  "
          return this.product.IntDuration + " min."
      },
      getProdPrice () {
          if (Vue.$storeSettings.IsHidePrices) return " "
          if ( parseFloat(this.product.Price) == 0) return " op aanvraag "
          var p = parseFloat(this.product.Price)
          return "€" + p.toFixed (2)
      },
      getPackageData () {
          var ret = ""
          for (var c=0; c < this.product.Childs.length; c++) {
             ret += this.product.Childs[c].Title + " | ";
          }
          return ret;
       }
    },
    computed: {
       hasPackageData () {
         this.urlPicCat = Vue.$currCatPicUrl;
         if (this.product.Childs == null) {return false;}
         if (this.product.Childs.length > 0) {return true;}
         return false;
       },
       getPicture () {
           this.urlPicCat = Vue.$currCatPicUrl;
           return this.urlPicCat; //Vue.$currCatPicUrl;
       }
     }
  }
</script>
<style>
  
  .bottom-center-prod {
    color: #111111;
    border-radius: 10px;
    font-weight: 500;
    min-height: 40px;
    max-width: 95%;
    margin-left: 5px;
    background-color: rgba(238, 238, 238, 0.5);
  }
 
</style>



// WEBPACK FOOTER //
// src/components/products/ProductItemLstView.vue